module.exports = __webpack_public_path__ + "img/closed.c2bb9ac5.svg";